"use client";
import { fontWeights } from "@/utils/fonts";
import { ServiceCard } from "../commonComponent/ServiceCard";

export function Services({
  title: cmsTitle,
  subtitle: cmsSubtitle,
  items: cmsItems,
  locationName,
  serviceName
}: {
  title?: string;
  subtitle?: string;
  items?: any[];
  locationName?: string;
  serviceName?: string;
}) {
  const replaceDynamicPlaceholders = (text?: string) => {
    if (!text) return text;
    return text
      .replace(/{location}/g, locationName || "")
      .replace(/{service}/g, serviceName || "");
  };

  const finalTitle = replaceDynamicPlaceholders(cmsTitle);
  const finalSubtitle = replaceDynamicPlaceholders(cmsSubtitle);

  const displayServices = (cmsItems || []).map((item: any) => ({
    ...item,
    title: replaceDynamicPlaceholders(item.title),
    description: replaceDynamicPlaceholders(item.description),
    iconWidth: item.iconWidth || '40',
    iconHeight: item.iconHeight || '35'
  }));

  if (!cmsTitle && !cmsSubtitle && displayServices.length === 0) {
    return null;
  }

  return (
    <section className="">
      <div className="mx-auto max-w-[1920px] px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2
            className="
            text-[24px]
            lg:text-[35px]
            2xl:text-[40px]
            3xl:text-[45px]
          h-auto
          tsm-350:h-[80px]
          sm:h-[40px]
          lg:h-[54px]
          max-h-[150px]
          w-auto
          tsm-350:w-[240px]
          sm:w-[600px]
          2xl:w-[813px]
          3xl:w-[963px]
          max-w-[963px]
          px-0
          sm:px-8
            mx-auto
            text-[#000000]
            "
            style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.semiBold }}
          >
            {finalTitle && <span dangerouslySetInnerHTML={{ __html: finalTitle }} />}
          </h2>
          {finalSubtitle && (
            <p
              className="
          leading-5
          my-[2px]
          sm:my-[10px]
          lg:my-[22px]
          2xl:my-[31px] 
          text-[15px]
          lg:text-[21px]
          2xl:text-[22px]
          h-auto
          tsm-350:h-[50px]
          max-h-[500px]
              mx-auto
              text-[#000000]
              "
              style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.medium }}
            >
              {finalSubtitle && <span dangerouslySetInnerHTML={{ __html: finalSubtitle }} />}
            </p>
          )}
        </div>
      </div>
      <div
        className="flex justify-center flex-wrap gap-[40px] mx-auto max-w-[1303px] px-4 sm:px-6 lg:px-8 m-16"
      >
        {displayServices.map((service: any, index: number) => (
          <ServiceCard
            key={`${service.title}-${index}`}
            title={service.title}
            description={service.description}
            icon={service.icon}
            iconWidth={service.iconWidth}
            iconHeight={service.iconHeight}
          />
        ))}
      </div>
    </section>
  );
}
